"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'YsImport',
  inject: {
    ysProviderContext: {
      default: () => ({
        api: {}
      })
    }
  },
  props: {
    title: {
      type: String,
      default: '导入'
    },
    accept: {
      type: String,
      default: '.xls,.xlsx'
    },
    maxCount: {
      type: Number,
      default: 1
    },
    uploadMethod: {
      type: Function,
      default: () => {}
    },
    /** 是否需要先调用校验数据准确性的接口、再进行提交 */
    validate: {
      type: Boolean,
      default: true
    },
    requestId: {
      type: String,
      default: undefined
    },
    errorDownloadMethod: {
      type: Function,
      default: () => {}
    },
    uploadConfirmMethod: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      downloadLoading: false,
      fileList: [],
      importResult: {},
      errorVisible: false,
      ignoreAndSubmitLoading: false,
      errorTableColumns: [{
        title: '表格序号',
        dataIndex: 'errorNum',
        width: 200
      }, {
        title: '错误字段',
        dataIndex: 'errorName',
        width: 200
      }, {
        title: '错误原因',
        dataIndex: 'errorReason'
      }]
    };
  },
  computed: {
    modelRequestId: {
      get() {
        return this.requestId;
      },
      set(value) {
        this.$emit('update:requestId', value);
      }
    },
    importResultMessage() {
      const {
        failNum,
        successNum
      } = this.importResult;
      return `文件上传成功，共${failNum + successNum}条数据，成功${successNum}条，失败${failNum}条，请调整后重新上传`;
    }
  },
  methods: {
    beforeUpload(file) {
      this.fileList.splice(0, this.fileList.length, file);
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      this.fileList.splice(index, 1);
    },
    close() {
      this.fileList = [];
      this.visible = false;
      this.$emit('cancel');
    },
    async handleConfirm() {
      if (!this.fileList.length) {
        this.$message.warn('请上传文件');
        return;
      }
      try {
        this.loading = true;
        if (this.validate) {
          const res = await this.uploadMethod(this.fileList);
          if (res.errorData?.length) {
            this.importResult = res;
            this.errorVisible = true;
            this.modelRequestId = res.requestId;
            return;
          }
          await this.uploadConfirmMethod(res.requestId);
        } else {
          await this.uploadConfirmMethod(this.fileList);
        }
        this.$message.success('导入完成');
        this.fileList = [];
        this.visible = false;
        this.$emit('submit');
      } finally {
        this.loading = false;
      }
    },
    async handleErrorFileDownload() {
      try {
        this.downloadLoading = true;
        await this.errorDownloadMethod(this.importResult.requestId);
      } finally {
        this.downloadLoading = false;
      }
    },
    async ignoreAndSubmit() {
      try {
        this.ignoreAndSubmitLoading = true;
        await this.uploadConfirmMethod(this.importResult.requestId);
        this.$message.success('导入完成');
        this.importResult = {};
        this.errorVisible = false;
        this.fileList = [];
        this.visible = false;
        this.$emit('submit');
      } finally {
        this.ignoreAndSubmitLoading = false;
      }
    },
    handleErrorCancel() {
      this.importResult = {};
      this.errorVisible = false;
    }
  }
};